/* Overcomers Journal — global behavior: mobile nav drawer. */

class OjNavDrawer extends HTMLElement {
  connectedCallback() {
    this.openButton = this.querySelector('[data-oj-drawer-open]');
    this.closeButton = this.querySelector('[data-oj-drawer-close]');
    this.backdrop = this.querySelector('[data-oj-drawer-backdrop]');
    this.drawer = this.querySelector('[data-oj-drawer]');

    this.onKeydown = (event) => {
      if (event.key === 'Escape') this.close();
    };

    this.openButton?.addEventListener('click', () => this.open());
    this.closeButton?.addEventListener('click', () => this.close());
    this.backdrop?.addEventListener('click', () => this.close());
    this.querySelectorAll('[data-oj-drawer] a').forEach((link) => {
      link.addEventListener('click', () => this.close());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
    document.body.style.overflow = '';
  }

  open() {
    this.classList.add('is-open');
    this.openButton?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this.onKeydown);
    this.closeButton?.focus();
  }

  close() {
    this.classList.remove('is-open');
    this.openButton?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this.onKeydown);
  }
}

if (!customElements.get('oj-nav-drawer')) {
  customElements.define('oj-nav-drawer', OjNavDrawer);
}

/* Clamped long text with a Read more / Read less toggle (collection
   descriptions). The toggle only appears when the text actually overflows. */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-oj-clamp]').forEach((block) => {
    const toggle = block.parentElement.querySelector('[data-oj-clamp-toggle]');
    if (!toggle) return;
    block.classList.add('is-clamped');
    if (block.scrollHeight > block.clientHeight + 2) {
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        const clamped = block.classList.toggle('is-clamped');
        toggle.textContent = clamped ? 'Read more' : 'Read less';
      });
    } else {
      block.classList.remove('is-clamped');
    }
  });
});

/* Keep the header cart count live after AJAX adds (cart drawer / notification).
   Dawn's product-form publishes cart-update through pubsub.js. */
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    fetch(`${window.routes?.cart_url || '/cart'}.js`)
      .then((response) => response.json())
      .then((cart) => {
        document.querySelectorAll('.oj-header__cart-count').forEach((el) => {
          el.textContent = cart.item_count;
        });
      })
      .catch(() => {});
  });
}
